/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DiscountCampaignShowResponse } from '../../models/discount-campaign-show-response';
import { DiscountCampaignShowResponse2 } from '../../models/discount-campaign-show-response-2';

export interface PatchDiscountUpdate$Params {
  id: string;
      body: DiscountCampaignShowResponse2
}

export function patchDiscountUpdate(http: HttpClient, rootUrl: string, params: PatchDiscountUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<DiscountCampaignShowResponse>> {
  const rb = new RequestBuilder(rootUrl, patchDiscountUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DiscountCampaignShowResponse>;
    })
  );
}

patchDiscountUpdate.PATH = '/v1/discount/{id}';
